import type { SVGProps } from 'react';
const SvgIconXLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M12.95 4.11a.75.75 0 0 0-1.06-1.06L8 6.69 4.11 3.05a.75.75 0 0 0-1.06 1.06L6.69 8l-3.64 3.89a.75.75 0 1 0 1.06 1.06L8 9.31l3.89 3.64a.75.75 0 0 0 1.06-1.06L9.31 8z"
    />
  </svg>
);
export default SvgIconXLarge;
